export default __webpack_public_path__ + "static/media/T36.1674dbc9.JPG";